const normalizeHandle = (handle) =>
    String(handle || "").replace(/^@/, "").trim().toLowerCase();

const PLATFORM_RULES = {
    instagram: /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-z0-9_.]{1,30}$/,
    tiktok:    /^[a-z0-9_.]{2,24}$/,
    youtube:   /^[a-zA-Z0-9._-]{3,30}$/,
    facebook:  /^[a-zA-Z0-9.]{5,50}$/,
};

const GENERIC_RULE = /^[a-z0-9_.-]{2,50}$/;

export const validateFormat = (platformKey, handle) => {
    const normalized = normalizeHandle(handle);
    const rule = PLATFORM_RULES[platformKey] ?? GENERIC_RULE;
    return rule.test(normalized);
};

export const normalizeHandleValue = (handle) => normalizeHandle(handle);
